import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { CustomContainer, MyButton } from "../StyledComponent/StyledComponent";
import Boy from "../../images/md-pervej-hossain.png";
import Resume from "../../file/Md Pervej Hossain Web developer.pdf";
import { Link } from "react-router-dom";

const AboutMe = () => {
  return (
    <CustomContainer id="about">
      <Container>
        <div className="text-light text-center mb-5">
          <h1 className="fw-bolder">About Me</h1>
        </div>
        <Row className="pt-5 g-5">
          <Col xs={12} md={6}>
            <img className="img-fluid" src={Boy} alt="" />
          </Col>
          <Col xs={12} md={6}>
            <h1 className="text-light" style={{ fontWeight: 600 }}>
              Md Pervej Hossain
            </h1>
            <p className="text-light pb-2 mt-2">
              My name is Md Pervej Hossain, I have completed Diploma Engineering
              in Mechanical Technology. But I enjoy more myself when I am
              coding. At firs, I started a query how to pursue and luckily
              reached a bootcamp course door. Where I have learned Web
              Development with the guideline of Jhankar Mahbub (Founder of
              Programming-hero).
              <br />
              <br />I started my journey with a company called TunicaLabs Media
              Pvt Ltd (Thane India). It's an remote internship job which I
              started since May 2022. There I colloborate in a team which was
              allocated to build an Australin project that is JamesHaride.
            </p>
            <Link to="aboutMe">
              <MyButton backgroundColor="transparent">Read More</MyButton>
            </Link>
            <a className="ms-lg-3 ms-sm-3 ms-0  my-4" href={Resume} download>
              <MyButton backgroundColor="white">Download Resume</MyButton>
            </a>
          </Col>
        </Row>
      </Container>
    </CustomContainer>
  );
};

export default AboutMe;
